export function parseUnderwritingStatus(
  resultsText: string | null | undefined,
): 'eligible' | 'ineligible' | 'unsure' | null {
  if (!resultsText) return null;

  const lowerResults = resultsText.toLowerCase();

  if (lowerResults.includes('\nineligible')) {
    return 'ineligible';
  } else if (lowerResults.includes('\neligible')) {
    return 'eligible';
  } else if (lowerResults.includes('\nunsure')) {
    return 'unsure';
  }
  return null;
}
